import { Link } from "react-router-dom";
import { ArrowLeft, Hourglass } from "lucide-react";
import { Button } from "@/components/ui/button";

const Placeholder = ({ title, eyebrow, description, testId }) => {
  return (
    <section
      className="relative overflow-hidden bg-white"
      data-testid={testId || "placeholder-page"}
    >
      <div className="pointer-events-none absolute inset-0 heritage-pattern opacity-60" />
      <div className="pointer-events-none absolute -top-24 right-0 h-96 w-96 rounded-full bg-apicon-mist blur-3xl" />

      <div className="relative mx-auto flex min-h-[calc(100vh-5rem)] w-full max-w-4xl flex-col items-start justify-center px-5 py-24 md:px-8">
        <span className="inline-flex items-center gap-2 rounded-full border border-apicon-navy/10 bg-apicon-mist px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-apicon-navy">
          <Hourglass className="h-3.5 w-3.5 text-apicon-gold" />
          {eyebrow}
        </span>

        <h1 className="mt-6 font-display text-5xl font-bold tracking-tight text-apicon-navy sm:text-6xl md:text-7xl">
          {title}
        </h1>

        <p className="mt-6 max-w-xl text-base leading-relaxed text-gray-600 sm:text-lg">
          {description}
        </p>

        <Link to="/" className="mt-10" data-testid="placeholder-home-link">
          <Button
            variant="outline"
            className="rounded-full border-apicon-navy/20 text-apicon-navy hover:border-apicon-navy hover:bg-apicon-mist"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to home
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default Placeholder;
